/* src/app/master-data/activity-type/edit-activity-type/edit-activity-type.component.css */
/*# sourceMappingURL=edit-activity-type.component-N5X4WEV4.css.map */
